var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconChevronDownBlack8Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "7px",
    viewBox: "0 0 10 7",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\xC4riklient",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Arved",
    transform: "translate(-350.000000, -196.000000)",
    stroke: "#000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(0.000000, 171.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path-3",
    points: "351 26 355 30 359 26"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChevronDownBlack8Px);
export default __webpack_public_path__ + "static/media/Icon_Chevron-Down_Black-8px.c9f006b8ece6f1c8474d9a917bba8b3f.svg";
export { ForwardRef as ReactComponent };